import FormTextField from '../../components/Form/FormTextField';
import { composeValidators, isValidPhoneOrEmail } from '../../components/Form/validations';

const formFieldData = [
  {
    ComponentType: FormTextField,
    fullWidth: true,
    label: 'Email',
    name: 'verificationType',
    required: true,
    validate: composeValidators(isValidPhoneOrEmail),
    mode: 'extraDark',
  },
];

export default formFieldData;
